import { Phone, Mail, MapPin } from 'lucide-react';
import { FaInstagram, FaFacebook, FaLinkedinIn } from 'react-icons/fa'; // Importa os ícones do Font Awesome
import Logo from '../../assets/imgs/logo.webp'; // Importa a sua logo

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative border-t border-border/20 overflow-hidden">
      {/* Giant "N" watermark */}
      <div className="absolute -bottom-20 -right-20 font-poppins font-black text-[40vw] leading-none text-muted/20 select-none pointer-events-none opacity-5">
        N
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <img src={Logo} alt="WebNorte Logo" className="w-12 h-12 object-contain invert" /> {/* Aumenta o tamanho da logo */}
              <span className="font-poppins font-bold text-lg text-foreground">
                Web<span className="gradient-text">Norte</span>
              </span>
            </div>
            <p className="font-inter text-sm text-muted-foreground leading-relaxed">
              Internet fibra óptica de alta velocidade para a sua região. 
              Conectamos você ao que importa.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-poppins font-semibold text-sm text-foreground mb-5 uppercase tracking-wider">
              Navegação
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Início', href: '#hero' },
                { label: 'Planos', href: '#planos' },
                { label: 'Benefícios', href: '#beneficios' },
                { label: 'Cobertura', href: '#cobertura' },
                { label: 'FAQ', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="font-inter text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-poppins font-semibold text-sm text-foreground mb-5 uppercase tracking-wider">
              Contato
            </h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" />
                <span className="font-inter text-sm text-muted-foreground">(69) 98127-4593</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" />
                <span className="font-inter text-sm text-muted-foreground">(69) 98433-3306</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary flex-shrink-0" />
                <span className="font-inter text-sm text-muted-foreground">contato@webnorte.com.br</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                <span className="font-inter text-sm text-muted-foreground">
                  Rua Santos Dummont, 1123 - Centro<br />
                  Nova União - RO
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                <span className="font-inter text-sm text-muted-foreground">
                  Av. Paraná, 4336 -  Centro - Setor 04<br />
                  Vale do Paraíso - RO
                </span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-poppins font-semibold text-sm text-foreground mb-5 uppercase tracking-wider">
              Redes Sociais
            </h4>
            <div className="flex gap-3">
              {[
                { name: 'Instagram', icon: FaInstagram, href: 'https://www.instagram.com/webnortetelecom/' },
                { name: 'Facebook', icon: FaFacebook, href: 'https://www.facebook.com/webnortetelecom' },
                { name: 'Linkedin', icon: FaLinkedinIn, href: 'https://www.linkedin.com/company/web-norte-telecom/' }, // Link do LinkedIn atualizado
              ].map((social) => {
                const Icon = social.icon;
                return (
                <a
                  key={social.name}
                  href={social.href} // Lembre-se de atualizar com os URLs reais
                  className="w-10 h-10 rounded-xl bg-muted/50 border border-border/30 flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-primary/30 hover:bg-primary/5 transition-all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon className="h-5 w-5" /> {/* Renderiza o ícone do Font Awesome */}
                </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-inter text-xs text-muted-foreground/60">
            © 2026 WebNorte Telecom. Todos os direitos reservados.
          </p>
          <p className="font-inter text-xs text-muted-foreground/60">
            CNPJ: 13.937.361/0001-00
          </p>
        </div>
      </div>
    </footer>
  );
}